var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 12.6663H16.6668V13.9997H15.3335V12.6663ZM15.3335 15.333H16.6668V19.333H15.3335V15.333ZM16.0002 9.33301C12.3202 9.33301 9.3335 12.3197 9.3335 15.9997C9.3335 19.6797 12.3202 22.6663 16.0002 22.6663C19.6802 22.6663 22.6668 19.6797 22.6668 15.9997C22.6668 12.3197 19.6802 9.33301 16.0002 9.33301ZM16.0002 21.333C13.0602 21.333 10.6668 18.9397 10.6668 15.9997C10.6668 13.0597 13.0602 10.6663 16.0002 10.6663C18.9402 10.6663 21.3335 13.0597 21.3335 15.9997C21.3335 18.9397 18.9402 21.333 16.0002 21.333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.12403de5182dd0a8cd74bac3086ec0dc.svg";
export { ForwardRef as ReactComponent };